module.exports = __webpack_public_path__ + "img/190.0340b3d9.jpg";